import SubscriptionSvg from "assets/svg/chain.svg";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { withTranslation } from "react-i18next";
import { Text } from "rebass";
import FolderList from "src/components/blocks/FolderList";
import { LinkButton } from "src/components/elements/Button";
import Title from "src/components/typography/Title";
import { Content } from "src/components/utilities/Containers";
import { svgStyle } from "src/styles/helpers";
import { breakpoints } from "src/styles/theme";
import styled from "styled-components";

const SubscriptionIcon = styled(SubscriptionSvg)`
  ${svgStyle};
  height: 2rem;

  @media (min-width: ${breakpoints.md}) {
    min-height: 2.6rem;
  }
`;

class UserFolders extends PureComponent {
  render() {
    const { t, folders } = this.props;

    return (
      <Content mt={3}>
        <Title sm icon={<SubscriptionIcon />}>
          {t("myChains")}
        </Title>
        <FolderList data={folders} />
        {folders.length >= 3 && (
          <Text pt={1} textAlign="center">
            <LinkButton to="/" css="width: 100%; max-width: 26rem;">
              {t("seeAllMyChain")}
            </LinkButton>
          </Text>
        )}
      </Content>
    );
  }
}

UserFolders.propTypes = {
  t: PropTypes.func,
  folders: PropTypes.array,
};

export default withTranslation()(UserFolders);
